import React, { useState } from "react";
import { Barricade, CaretDown, ArrowSquareOut } from "@phosphor-icons/react";
import { relTime } from "../lib/incidents";
import PerimeterMapModal from "./PerimeterMapModal";

export default function EmRoadClosuresCard({ closures = [], onFlyTo, onSelect }) {
  const [open, setOpen] = useState(false);
  const [perimUrl, setPerimUrl] = useState(null);
  if (closures.length === 0) return null;

  return (
    <section data-testid="em-road-closures-card" className="border-b border-tac-danger/40 bg-tac-surface/40">
      <button
        type="button"
        data-testid="em-road-closures-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-tac-surface/60 transition-colors"
      >
        <Barricade size={14} weight="fill" className="text-tac-danger" />
        <span className="text-[12px] uppercase tracking-[0.15em] font-bold text-tac-text">
          County EM Road Closures
        </span>
        <span className="text-[15px] font-mono-tac tabular text-tac-danger">· {closures.length}</span>
        <CaretDown
          size={12}
          weight="bold"
          className={`text-tac-dim transition-transform ml-auto ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <ul className="divide-y divide-tac-border/50" data-testid="em-road-closures-list">
          {closures.map((c) => (
            <li key={c.id} data-testid={`road-closure-${c.id}`} className="px-4 py-2.5">
              <button
                type="button"
                onClick={() => (onSelect ? onSelect(c) : onFlyTo?.(c.latitude, c.longitude))}
                className="w-full text-left group"
              >
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[15px] font-semibold text-tac-text group-hover:text-tac-primary transition-colors">
                    {c.name}
                  </span>
                  <span className="text-[12px] font-mono-tac text-tac-faint ml-auto shrink-0">
                    {relTime(c.updated_at)}
                  </span>
                </div>
                {c.description && (
                  <div className="text-[14px] text-tac-dim leading-snug whitespace-pre-line">
                    {c.description}
                  </div>
                )}
              </button>
              {c.source_url && (
                <button
                  type="button"
                  onClick={() => setPerimUrl(c.source_url)}
                  className="inline-flex items-center gap-1 mt-1 text-[12px] font-bold uppercase tracking-wider text-tac-dim hover:text-tac-text"
                >
                  Perimeter map <ArrowSquareOut size={10} weight="bold" />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {open && (
        <div className="px-4 py-1.5 text-[11px] font-mono-tac text-tac-faint border-t border-tac-border/40">
          Auto-synced from County EM (Perimeter)
        </div>
      )}
      {perimUrl && (
        <PerimeterMapModal url={perimUrl} title="County EM Perimeter Map" onClose={() => setPerimUrl(null)} />
      )}
    </section>
  );
}
